export default __webpack_public_path__ + "static/media/temp.e0678591.svg";